import React from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import { FILTER_KEY_CREATIVE } from 'app/constants/filters';
import MultiTreeBackend from '../Base/MultiTreeBackend/MultiTreeBackend';
import CampaignOrCreativePanel from '../Base/Panels/CampaignOrCreativePanel';
import { getDefaultCheckedNodes } from '../Base/Panels/helper';

const MultiTreeCreative = ({
  visible,
  searchParams,
  availableNodes,
  defaultCheckedNodes,
  dropdownFixed,
  onVisibleChange,
  onChange,
  onRemove,
}) => {
  const checkedNodes = getDefaultCheckedNodes(defaultCheckedNodes);
  return (
    <MultiTreeBackend
      dropdownFixed={dropdownFixed}
      visible={visible}
      filterKey={FILTER_KEY_CREATIVE}
      defaultCheckedNodes={checkedNodes}
      renderOverlay={() => (
        React.createElement(CampaignOrCreativePanel, {
          visible,
          searchParams,
          availableNodes,
          filterKey: FILTER_KEY_CREATIVE,
          defaultCheckedNodes: checkedNodes,
          onVisibleChange,
          onChange,
        })
      )}
      onVisibleChange={onVisibleChange}
      onChange={onChange}
      onRemove={onRemove}
    />
  );
};

MultiTreeCreative.propTypes = {
  visible: PropTypes.bool.isRequired,
  searchParams: PropTypes.objectOf(PropTypes.any),
  availableNodes: PropTypes.arrayOf(PropTypes.any),
  defaultCheckedNodes: PropTypes.arrayOf(PropTypes.any),
  dropdownFixed: PropTypes.bool,
  onVisibleChange: PropTypes.func,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
};

MultiTreeCreative.defaultProps = {
  searchParams: {},
  availableNodes: [],
  defaultCheckedNodes: [],
  dropdownFixed: false,
  onVisibleChange: noop,
  onChange: noop,
  onRemove: noop,
};

export default MultiTreeCreative;
